import VideoCamera from "./SVG/meeting-camera.svg?react";

const VideoCameraIcon = () => {
  return <VideoCamera />;
};

export default VideoCameraIcon;
